module.exports = __webpack_public_path__ + "img/Discord Icon.9365e9a6.svg";